import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MeteorObservable } from 'meteor-rxjs';
import { Observable, Subscription } from 'rxjs';
import { jobCanceledCancelReason } from 'server/helpers/defaultCancelReasons';
import { Customers } from 'server/shared/collections/customers';
import { UserLogs } from 'server/shared/collections/userLogs';
import { Users } from 'server/shared/collections/users';
import { Customer } from 'server/shared/models/customer';
import { DeclineReasonEnum } from 'server/shared/models/declineReason.enum';
import { InpoolLanguage } from 'server/shared/models/InpoolLanguage';
import { Invitee } from 'server/shared/models/invitee';
import { LogEntry } from 'server/shared/models/logEntry';
import { UserLogEnum } from 'server/shared/models/notificationEnum';
import { RoleEnum } from 'server/shared/models/role.enum';
import { DispoUser } from 'server/shared/models/user';
import { TranslationService } from '../../../../services/translation.service';

@Component({
  selector: 'user-logs-bottom-sheet',
  templateUrl: 'user-logs-bottom-sheet.html',
  styleUrls: ['user-logs-bottom-sheet.scss'],
})
export class UserLogsBottomSheetComponent implements OnInit, OnDestroy {
  userLogs?: Observable<LogEntry[]>;
  userLogEnum = UserLogEnum;
  declineReasonEnum = DeclineReasonEnum;
  lang: InpoolLanguage = 'de';
  userLogsSubscription?: Subscription;
  loggedInCustomer?: Customer;

  jobCanceledCancelReasonId = jobCanceledCancelReason.id;

  userLogsTracker?: Tracker.Computation;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      customerId: string;
      invitee: Invitee;
      jobId: string;
      cancelReasonDescription?: string;
    },
    private translationService: TranslationService,
    private ngZone: NgZone,
  ) {}

  ngOnInit() {
    this.userLogsSubscription = MeteorObservable.subscribe(
      'logsOfInvitees',
      this.data.jobId,
    ).subscribe();
    this.userLogsTracker = Tracker.autorun(() => {
      this.userLogs = UserLogs.find(
        { inviteeId: this.data.invitee.id },
        { sort: { timestamp: 1 } },
      );

      let loggedInUser = Users.findOne({
        _id: Meteor.userId(),
        role: RoleEnum.DISPO,
      }) as DispoUser;
      if (loggedInUser) {
        this.loggedInCustomer = Customers.findOne({
          _id: loggedInUser.customerId,
        });
        this.userLogs?.subscribe((logs) => {
          logs.forEach((log) => {
            if (
              !log.customerId ||
              this.loggedInCustomer?._id === log.customerId
            )
              return;
            let viaCustomer = Customers.findOne({
              _id: log.customerId,
            });
            if (viaCustomer) {
              log.viaCustomer = {
                id: viaCustomer._id,
                displayName: viaCustomer.name,
              };
            }
          });
        });
      }
    });
    Tracker.autorun(() => {
      this.ngZone.run(() => {
        this.lang = this.translationService.getLanguage();
      });
    });
  }

  ngOnDestroy() {
    this.userLogsSubscription?.unsubscribe();
    this.userLogsTracker?.stop();
  }
}
